import { getEventBridge } from '@datadog/browser-core';
export function startRumEventBridge(lifeCycle) {
  const bridge = getEventBridge();
  lifeCycle.subscribe(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent => {
    bridge.send('rum', serverRumEvent);
  });
}
